import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ArrowRightIcon = createIcon(
  'ArrowRight',
  <path
    id="a"
    d="M9.2925,15.4625 L13.1725,11.5825 L9.2925,7.7025 C8.9025,7.3125 8.9025,6.6825 9.2925,6.2925 C9.6825,5.9025 10.3125,5.9025 10.7025,6.2925 L15.2925,10.8825 C15.6825,11.2725 15.6825,11.9025 15.2925,12.2925 L10.7025,16.8825 C10.3125,17.2725 9.6825,17.2725 9.2925,16.8825 C8.9125,16.4925 8.9025,15.8525 9.2925,15.4625 Z"
  />
);

export default ArrowRightIcon;
